import styled from 'styled-components'

import { boxModelTypes, cssTypes } from '../types'
import { boxModel, css } from '../util'

/**
 * @namespace Video
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Video = styled.video`
  ${boxModel};
  ${css};
`

/**
 * @name defaultProps
 * @memberof Video
 * @desc Primitive's default properties
 */
Video.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto', '100%'],
}

/**
 * @name propTypes
 * @memberof Video
 * @desc Primitive's prop type definitions
 */
Video.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default Video
